import angular, { IPromise } from "angular";
import { IVehicleInput } from "@interfaces/IVehicleInput";
import { VehicleInputService, IVehicleInputRecordHistory } from "@services/vehicleInput.service";
import { IAlertRuleRecord } from "src/app/main/modules/alerts/_models/alerts.interfaces";
import { InputTypeService } from "@services/inputType.service";
import { IInputType } from "@interfaces/IInputType";

export interface IInputAlertDetailData {
    input?: IVehicleInput;
    inputHistory?: IVehicleInputRecordHistory;
    inputType?: IInputType;
    inputTypes?: IInputType[];
}

export class InputAlertDetailService {
    static $inject = ["$q", "inputTypeService", "vehicleInputService"];

    constructor(
        private readonly $q: angular.IQService,
        private readonly inputTypeService: InputTypeService,
        private readonly vehicleInputService: VehicleInputService) {
    }

    getAlertExport(record: IAlertRuleRecord): IPromise<string> {
        return this.getAlertData(record).then((data) => {
            return `${this.createAlertLabel(data)}`;
        }).catch((error) => {
            console.error("Error retrieving input alert detail: ", error);

            return null
        });
    }

    createAlertLabel(data: IInputAlertDetailData) {
        return `${data.input.name} (${data.inputHistory?.inputStateDescription})`;
    }

    getAlertData(record: IAlertRuleRecord): IPromise<IInputAlertDetailData> {
        const promises = [];
        const data: IInputAlertDetailData = {};

        promises.push(this.getInput(record, data));
        promises.push(this.getInputHistory(record, data));
        promises.push(this.getInputTypes(data));

        return this.$q.all(promises).then(() => {
            data.inputType = data.inputTypes.find(i => i.Id === data.input.InputTypeId);
            return data;
        });
    }

    private getInput(record: IAlertRuleRecord, data: IInputAlertDetailData) {
        if (!record.alertMetadata.InputId) {
            return this.$q.resolve();
        }

        return this.vehicleInputService.getVehicleInputs(record.VehicleId).then(inputs => {
            data.input = inputs.find(i => i.Id === record.alertMetadata.InputId);
        });
    }

    private getInputHistory(record: IAlertRuleRecord, data: IInputAlertDetailData) {
        if (!record.alertMetadata.InputRecordHistoryId) {
            return this.$q.resolve();
        }

        return this.vehicleInputService.getVehicleInputHistoryById(record.alertMetadata.InputRecordHistoryId).then(
            history => {
                data.inputHistory = history;
            });
    }

    private getInputTypes(data: IInputAlertDetailData) {
        return this.inputTypeService.getInputTypes().then(types => {
            data.inputTypes = types;
        });
    }
}
